/* Loop 2 R9: procurement helpers for the quote drawer (snippets/quote-drawer.liquid). Loaded after assets/imm.js.
   - "Required by" date cannot be in the past.
   - "Print / save request as PDF": builds a one-page summary of the quote list plus the filled drawer fields
     (PO / internal reference, required-by date, calibration documents, note) and opens the browser print dialog
     (same window.print path as the R13 spec sheet). No reference number is generated; styles in assets/imm-qprint.css. */
(function () {
  // R10b: list prices may carry thousands separators ("1,188.00"); a line counts as priced only when finite
  function num(v) {
    var s = String(v == null ? '' : v).replace(/[$,\s]/g, '');
    var n = s === '' ? NaN : Number(s);
    return isFinite(n) ? n : NaN;
  }
  function total(a) {
    var sum = 0, priced = 0;
    a.forEach(function (it) { var p = num(it.p); if (!isNaN(p)) { sum += p * (Math.max(1, parseInt(it.q, 10) || 1)); priced++; } });
    return { sum: Math.round(sum * 100) / 100, priced: priced };
  }
  window.immPriceNum = num; window.immQTotal = total;
  var qd = document.querySelector('[data-imm-qd]');
  var form = qd && qd.querySelector('[data-imm-qform]');
  if (!form) return;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var now = new Date(), today = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
  var date = form.querySelector('[name="contact[required_by]"]');
  if (date) {
    date.min = today;
    if (date.value && date.value < today) date.value = '';   // R10b: a restored deadline that has passed is dropped
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function load() { try { return JSON.parse(localStorage.getItem('imm_quote')) || []; } catch (e) { return []; } }
  function val(n) {
    var f = form.querySelector('[name="contact[' + n + ']"]');
    if (!f) return '';
    if (f.tagName === 'SELECT') return f.value ? f.options[f.selectedIndex].text : '';
    return String(f.value || '').trim();
  }
  function money(v) { return '$' + Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function longDate(iso) {
    var p = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    return p ? new Date(+p[1], +p[2] - 1, +p[3]).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : iso;
  }

  function build() {
    var a = load(), tt = total(a), sum = tt.sum, priced = tt.priced;
    var who = [['Name', val('name')], ['Company', val('company')], ['Email', val('email')], ['Ship to', val('country')],
      ['PO / internal reference', val('po_reference')], ['Required by', longDate(val('required_by'))],
      ['Calibration documents', val('certificate')], ['Note', val('body')]].filter(function (r) { return r[1]; });
    var rows = a.map(function (it, i) {
      var q = Math.max(1, parseInt(it.q, 10) || 1), p = num(it.p);
      return '<tr><td>' + (i + 1) + '</td><td>' + q + '</td><td>' + esc(it.u ? it.v : '') + '</td><td><b>' + esc(it.t) + '</b>' +
        (it.u ? '<small>' + esc(location.origin + it.u) + '</small>' : '<small>Part number, not in the online catalogue</small>') +
        (it.n ? '<small>Note: ' + esc(it.n) + '</small>' : '') + '</td><td>' + (!isNaN(p) ? money(p) : '&ndash;') + '</td></tr>';
    }).join('');
    var el = document.createElement('div');
    el.className = 'imm-qprint';
    el.innerHTML =
      '<div class="imm-qprint__head"><div><b>' + esc(qd.getAttribute('data-shop')) + '</b><br>' + esc(qd.getAttribute('data-shop-addr')) + '<br>' + esc(qd.getAttribute('data-shop-email')) + ' &middot; ' + esc(location.host) + '</div>' +
      '<div class="imm-qprint__meta"><b>Request for quotation</b><br>Prepared ' + esc(longDate(today)) + '<br>' + a.length + ' line' + (a.length === 1 ? '' : 's') + '</div></div>' +
      (who.length ? '<dl class="imm-qprint__who">' + who.map(function (r) { return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('') + '</dl>' : '') +
      '<table class="imm-qprint__t"><thead><tr><th>#</th><th>Qty</th><th>Brand</th><th>Product</th><th>List price (USD)</th></tr></thead><tbody>' + rows + '</tbody>' +
      (priced ? '<tfoot><tr><td colspan="4">Sum of list prices &times; quantity' + (priced < a.length ? ' (' + priced + ' of ' + a.length + ' lines have a list price)' : '') + '</td><td>' + money(sum) + '</td></tr></tfoot>' : '') + '</table>' +
      '<p class="imm-qprint__foot">List prices are indicative; the quote confirms price and availability for every line. Payment by card or bank transfer with a proforma invoice. 30-day money-back on defects. We ship worldwide. Typical reply: one working day.' +
      (qd.getAttribute('data-proc-url') ? ' How we work with companies (PO, proforma invoice, payment): ' + esc(location.origin + qd.getAttribute('data-proc-url')) : '') + '</p>';
    return el;
  }

  var cur = null;
  function cleanup() { if (cur) { cur.remove(); cur = null; } document.documentElement.classList.remove('imm-qprinting'); }
  window.addEventListener('afterprint', cleanup);
  qd.addEventListener('click', function (e) {
    if (!e.target.closest('[data-imm-qprint]')) return;
    if (!load().length) return;
    cleanup();
    cur = build();
    document.body.appendChild(cur);
    document.documentElement.classList.add('imm-qprinting');
    setTimeout(function () { window.print(); }, 60);   // removed on afterprint; hidden on screen anyway
  });
})();
